import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "data-table__column-selection" };
const _hoisted_2 = ["title"];
const _hoisted_3 = {
    key: 0,
    class: "dropdown__item dropdown__item--section"
};
const _hoisted_4 = {
    key: 1,
    class: "dropdown__item dropdown__item--filter"
};
const _hoisted_5 = ["placeholder"];
import { computed, ref } from 'vue';
import AppDropdown from "../AppDropdown.vue";
import Icon from "../Icon.vue";
import DataTableColumnSelectionItem from "./DataTableColumnSelectionItem.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DataTableColumnsSelection',
    props: {
        columns: {},
        modified: { type: Boolean }
    },
    emits: ["toggle", "resize", "sort", "reset"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const columnFilter = ref(null);
        const selectedColumns = computed(() => props.columns.filter(col => col.selected));
        const availableColumns = computed(() => props.columns.filter(col => !col.selected));
        const availableFilteredColumns = computed(() => {
            const filter = columnFilter.value?.toLowerCase();
            if (!filter) {
                return availableColumns.value;
            }
            return availableColumns.value.filter(col => {
                return (col.label && col.label.toLowerCase().indexOf(filter) !== -1)
                    || (col.name && col.name.toLowerCase().indexOf(filter) !== -1);
            });
        });
        const dragInProgress = ref(false);
        const dragSourceColumn = ref(null);
        const dragTargetColumn = ref(null);
        function closestColumnName(event) {
            const closestColumn = event.target?.closest('[data-column]');
            return closestColumn ? closestColumn.getAttribute('data-column') : null;
        }
        function onDragStart(event) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.dropEffect = 'move';
            dragSourceColumn.value = closestColumnName(event);
            dragInProgress.value = true;
        }
        function onDragOver(event) {
            event.preventDefault();
            dragTargetColumn.value = closestColumnName(event);
        }
        function onDragEnd(event) {
            event.preventDefault();
            if (dragTargetColumn.value !== dragSourceColumn.value) {
                const newColumnsOrder = [];
                selectedColumns.value.forEach(column => {
                    // No drag target => Put at the beginning
                    if (dragTargetColumn.value === null && newColumnsOrder.length === 0) {
                        newColumnsOrder.push(dragSourceColumn.value);
                    }
                    // No change
                    if (column.name !== dragSourceColumn.value) {
                        newColumnsOrder.push(column.name);
                    }
                    // Put source column after target column
                    if (column.name === dragTargetColumn.value) {
                        newColumnsOrder.push(dragSourceColumn.value);
                    }
                });
                emit('sort', newColumnsOrder);
            }
            dragInProgress.value = false;
            dragSourceColumn.value = null;
            dragTargetColumn.value = null;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(AppDropdown, {
                    "button-style": "link",
                    position: "left"
                }, {
                    button: _withCtx(() => [
                        _createVNode(Icon, {
                            name: "columns",
                            "icon-style": "light"
                        })
                    ]),
                    menu: _withCtx(() => [
                        _createElementVNode("div", {
                            onDragstart: onDragStart,
                            onDragenter: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["prevent"])),
                            onDragover: onDragOver,
                            onDragend: onDragEnd
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["dropdown__item dropdown__item--section", { 'data-table__column-selection-drag-target': dragInProgress.value && dragTargetColumn.value === null }])
                            }, [
                                _createTextVNode(_toDisplayString(_ctx.$t('columns.selected')) + " ", 1),
                                (__props.modified)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (emit('reset')), ["prevent"])),
                                        href: "",
                                        draggable: false,
                                        class: "data-table__column-selection-reset",
                                        title: _ctx.$t('columns.reset')
                                    }, [
                                        _createVNode(Icon, { name: "rotate-left" })
                                    ], 8, _hoisted_2))
                                    : _createCommentVNode("", true)
                            ], 2),
                            _cache[6] || (_cache[6] = _createTextVNode()),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedColumns.value, (col) => {
                                return (_openBlock(), _createBlock(DataTableColumnSelectionItem, {
                                    column: col,
                                    key: col.name,
                                    sortable: true,
                                    resizable: true,
                                    class: _normalizeClass({ 'data-table__column-selection-drag-target': dragTargetColumn.value === col.name }),
                                    onToggle: _cache[1] || (_cache[1] = ($event) => (emit('toggle', $event))),
                                    onResize: _cache[2] || (_cache[2] = (column, size) => emit('resize', column, size))
                                }, null, 8, ["column", "class"]));
                            }), 128))
                        ], 32),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        (availableColumns.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('columns.available')), 1))
                            : _createCommentVNode("", true),
                        _cache[8] || (_cache[8] = _createTextVNode()),
                        (availableColumns.value.length > 10)
                            ? (_openBlock(), _createElementBlock("label", _hoisted_4, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((columnFilter).value = $event)),
                                    placeholder: _ctx.$t('search.placeholder')
                                }, null, 8, _hoisted_5), [
                                    [_vModelText, columnFilter.value]
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _cache[9] || (_cache[9] = _createTextVNode()),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableFilteredColumns.value, (col) => {
                            return (_openBlock(), _createBlock(DataTableColumnSelectionItem, {
                                column: col,
                                key: col.name,
                                sortable: false,
                                resizable: false,
                                onToggle: _cache[5] || (_cache[5] = ($event) => (emit('toggle', $event)))
                            }, null, 8, ["column"]));
                        }), 128))
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
